import { jsx as _jsx } from "react/jsx-runtime";
import { ResponsiveLayout } from "./ResponsiveLayout";
import { HouseLineIcon, PersonArmsSpreadIcon, CloudIcon, GearIcon, } from '@phosphor-icons/react';
export default function AppLayout() {
    return _jsx(ResponsiveLayout, { navLinks: [
            { icon: HouseLineIcon, label: 'Dashboard', to: '/' },
            { icon: PersonArmsSpreadIcon, label: 'Children', to: '/children' },
            { icon: CloudIcon, label: 'Clouds', to: '/clouds' },
            { icon: GearIcon, label: 'Account', to: '/account' },
        ] });
}
